import { forwardRef } from "react";
import { Button as PrimerButton } from "@primer/react";
import "./Button.css";

export const Button = forwardRef(function Button({ children, className = "", labelDetail, tone = "primary", ...props }, ref) {
  const variant = {
    primary: "primary",
    secondary: "default",
    quiet: "invisible",
    danger: "danger"
  }[tone];

  return (
    <PrimerButton ref={ref} className={`app-button ${className}`.trim()} variant={variant} aria-label={labelDetail ? `${children} ${labelDetail}` : undefined} {...props}>
      {children}{labelDetail ? <span className="button-label-detail" aria-hidden="true"> {labelDetail}</span> : null}
    </PrimerButton>
  );
});
